import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { DataSaverProvider } from "@/context/DataSaverContext";
import Layout from "@/components/layout/Layout";

import Home from "@/pages/Home";
import Candidates from "@/pages/Candidates";
import CandidateProfile from "@/pages/CandidateProfile";
import Delegations from "@/pages/Delegations";
import DelegationDetail from "@/pages/DelegationDetail";
import Vote from "@/pages/Vote";
import Watch from "@/pages/Watch";
import Press from "@/pages/Press";
import Predictions from "@/pages/Predictions";
import Events from "@/pages/Events";
import Impact from "@/pages/Impact";
import News from "@/pages/News";
import Sponsors from "@/pages/Sponsors";
import Support from "@/pages/Support";
import About from "@/pages/About";
import More from "@/pages/More";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Account from "@/pages/Account";
import Admin from "@/pages/Admin";
import Apply from "@/pages/Apply";
import Judge from "@/pages/Judge";
import Director from "@/pages/Director";
import DirectorClaim from "@/pages/DirectorClaim";
import Coronation from "@/pages/Coronation";
import Alumni from "@/pages/Alumni";
import Shop from "@/pages/Shop";
import Membership from "@/pages/Membership";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import AuthCallback from "@/pages/AuthCallback";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => window.scrollTo(0, 0), [pathname]);
  return null;
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Layout><Home /></Layout>} />
        <Route path="/about" element={<Layout><About /></Layout>} />
        <Route path="/candidates" element={<Layout><Candidates /></Layout>} />
        <Route path="/candidates/:slug" element={<Layout><CandidateProfile /></Layout>} />
        <Route path="/delegations" element={<Layout><Delegations /></Layout>} />
        <Route path="/delegations/:code" element={<Layout><DelegationDetail /></Layout>} />
        <Route path="/vote" element={<Layout><Vote /></Layout>} />
        <Route path="/watch" element={<Layout><Watch /></Layout>} />
        <Route path="/press" element={<Layout><Press /></Layout>} />
        <Route path="/predictions" element={<Layout><Predictions /></Layout>} />
        <Route path="/events" element={<Layout><Events /></Layout>} />
        <Route path="/impact" element={<Layout><Impact /></Layout>} />
        <Route path="/news" element={<Layout><News /></Layout>} />
        <Route path="/sponsors" element={<Layout><Sponsors /></Layout>} />
        <Route path="/support" element={<Layout><Support /></Layout>} />
        <Route path="/more" element={<Layout><More /></Layout>} />
        <Route path="/apply" element={<Layout><Apply /></Layout>} />
        <Route path="/coronation" element={<Layout hideStatus><Coronation /></Layout>} />
        <Route path="/alumni" element={<Layout><Alumni /></Layout>} />
        <Route path="/shop" element={<Layout><Shop /></Layout>} />
        <Route path="/membership" element={<Layout><Membership /></Layout>} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/account" element={<Layout><Account /></Layout>} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/judge" element={<Judge />} />
        <Route path="/director" element={<Director />} />
        <Route path="/director/claim" element={<DirectorClaim />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />
      </Routes>
    </>
  );
}

export default function App() {
  return (
    <DataSaverProvider>
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
          <Toaster position="top-center" theme="dark" richColors closeButton />
        </BrowserRouter>
      </AuthProvider>
    </DataSaverProvider>
  );
}
